import { 
	GET_PROJECT_QA_WELDING_INSPECTIONS_WELDING_TYPES, 
	GET_PROJECT_QA_WELDING_INSPECTIONS_WELDING_TYPE,
	CREATE_PROJECT_QA_WELDING_INSPECTIONS_WELDING_TYPE,
	UPDATE_PROJECT_QA_WELDING_INSPECTIONS_WELDING_TYPE,
	DESTROY_PROJECT_QA_WELDING_INSPECTIONS_WELDING_TYPE,
} from "./actions"

export function ProjectQaWeldingInspectionsWeldingTypesReducer(state = {}, action) {
	switch (action.type) {
		case `${GET_PROJECT_QA_WELDING_INSPECTIONS_WELDING_TYPES}_FULFILLED`:{
			return _.mapKeys(action.payload.data, "id");
		}
		case `${GET_PROJECT_QA_WELDING_INSPECTIONS_WELDING_TYPE}_FULFILLED`:
		case `${CREATE_PROJECT_QA_WELDING_INSPECTIONS_WELDING_TYPE}_FULFILLED`:
		case `${UPDATE_PROJECT_QA_WELDING_INSPECTIONS_WELDING_TYPE}_FULFILLED`:{
			let newState = _.clone(state);
			const newItem = action.payload.data;
			const id = _.get(newItem,"id")
			newState[id] = newItem
			return newState;
		}		
		case `${DESTROY_PROJECT_QA_WELDING_INSPECTIONS_WELDING_TYPE}_FULFILLED`:{
			let newState = _.clone(state);
			const deletedItem = action.payload.data;
			const id = _.get(deletedItem,"id")
			newState = _.filter(newState,i => i.id != id)
			return newState;
		}
		default:
			return state;
	}
}

// Move this to the reducer page
// import { ProjectQaWeldingInspectionsWeldingTypesReducer } from "modules/project/qa/welding_inspections/welding_types/reducer"

// project_qa_welding_inspections_welding_types:ProjectQaWeldingInspectionsWeldingTypesReducer,
